
console.log('Case Study Archive Frontend JS Loaded')
import { gsap } from 'gsap';
const select = document.querySelector('.filters select')

const urlParams = new URLSearchParams(window.location.search);
let payload = {}
urlParams.forEach((value, key) => {
    if( value ) {
        payload[key] = value;
    }
});

select.addEventListener('change', e => {
    if( e.target.value ) {
        payload.service = e.target.value
    } else {
        delete payload.service;
    }
    queryAPI(payload)
})

const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};

document.querySelector('.filters input[name="search"]').addEventListener('input', debounce(e => {
    payload.s = e.target.value;
    queryAPI(payload);
}, 500));
    

const tags = document.querySelectorAll('.tag-list a') 

tags.forEach( tag => tag.addEventListener('click', e => {
    e.preventDefault();
    tags.forEach( tag => tag.classList.remove('active'));
    tag.classList.add('active');
    payload.tag = tag.dataset.tag;
    queryAPI(payload);
}))


async function queryAPI(payload) {
    
    const query = Object.entries(payload).map(([key, value]) => `${key}=${value}`).join('&');
    window.history.pushState(null, null, `?${query}`);

    const request = await fetch( '/wp-json/seoworks/v1/case_studies', {
        method: 'POST',
        headers: {
            'Accept': 'text/html',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify( payload )
    });

    const res = await request.json()
    document.querySelector('.case-study-archive-reults').innerHTML = res?.template
    document.querySelectorAll('.result-count').forEach(el => el.innerHTML = res?.count)

}


const toggledContent = document.querySelector('.toggled-content');
const mobileToggleSvg = document.querySelector('.mobile-toggle .toggle svg');
document.querySelector('.mobile-toggle .toggle').addEventListener('click', e => {
    toggledContent.classList.toggle('active');
    gsap.to(mobileToggleSvg, { rotate: toggledContent.classList.contains('active') ? '180' : '0', duration: 0.5 });
    gsap.to(toggledContent, { height: toggledContent.classList.contains('active') ? 'auto' : '0', duration: 0.5 });
})
